// app/src/entities/user/ui/UserCard/components/UserRolesIcons.jsx
import React from 'react';
import { ROLE_CONFIG } from '../constants/cardConstants';

const UserRolesIcons = ({ roles, showTooltip, hideTooltip }) => {
  if (!roles || roles.length === 0) return null;

  return (
    <div className="user-roles-icons">
      {roles.map((role, index) => {
        const config = ROLE_CONFIG[role.type];
        if (!config) return null;

        // Ensure we get the icon component correctly
        const Icon = config.icon;

        return (
          <span
            key={index}
            className={`user-role-icon role-${role.type}`}
            style={{ color: config.color }}
            onMouseEnter={(e) => showTooltip?.(config.name, config.description)}
            onMouseLeave={hideTooltip}
          >
            <Icon />
          </span>
        );
      })}
    </div>
  );
};

export default UserRolesIcons;
